<template>
    <div>
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Loading
    </div>
</template>